import { useEffect, useState } from "react";
import cx from "classnames";
import styles from "./MainNavbar1Dark.module.css";
import redSmyle from "../../../images/smileRed.svg";
import Image from "next/image";

import { motion } from "framer-motion";
import uuid from "react-uuid";

import Link from "next/link";
import { navMainTitle } from "../../Data/navbarData";
import { navbarData } from "../../Data/navbarData";
import { sharedData } from "../../Data/sharedData";
import { useRouter } from "next/router";
import Hamburger from 'hamburger-react'

const desktopSubMenuUuid = uuid();
const mobileMainMenuUuid = uuid();

const MainNavbar1Dark = () => {
  const router = useRouter();
  const [scroll, setScroll] = useState(false);
  const [subMenuOpen, setSubMenuOpen] = useState(false);
  const [activeSubMenu, setActiveSubMenu] = useState(undefined);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [subMobileMenuOpen, setSubMobileMenuOpen] = useState(false);
  const [activeSubMobileMenu, setActiveSubMobileMenu] = useState(undefined);

  const changeBackground = () => {
    if (window.scrollY >= 20) {
      setScroll(true);
    } else {
      setScroll(false);
    }
  };

  useEffect(() => {
    changeBackground();
    // adding the event when scroll change Logo
    window.addEventListener("scroll", changeBackground);
  });

  const onSubMobileMenuHandler = (selectedId) => {
    if (navbarData.filter((i) => i.id === selectedId)[0]?.subMenu?.length > 0) {
      setActiveSubMobileMenu(selectedId);
      setSubMobileMenuOpen(true);
    }
  };
  return (
    <div
      onMouseLeave={() => {
        setSubMenuOpen(false);
      }}
    >
      <div
        className={cx(
          styles.container,
          scroll && styles.secondContainerBg,
          "d-flex",
          "align-items-center",
          "justify-content-center",
          "w-100"
        )}
      >
        <div
          className={cx(
            styles.hamMenuWrapper,
            "d-flex",
            "align-items-center",
            "justify-content-center",
            "d-lg-none"
          )}
        >
          <Hamburger toggled={mobileMenuOpen} toggle={setMobileMenuOpen} size={20} easing="ease-in" rounded color="#e0e0e0" />

          {/* {mobileMenuOpen ? (
            <motion.button
              key={!mobileMenuOpen ? uuid() : "closeuuid"}
              className="d-flex align-items-center justify-content-center p-0"
              onClick={() => {
                setMobileMenuOpen(!mobileMenuOpen);
                setSubMobileMenuOpen(false);
              }}
              initial={{ rotate: 80 }}
              animate={{ rotate: 0 }}
              transition={{ stiffness: 90 }}
            >
              <Image
                width={20}
                height={14}
                src={closeSvg}
                alt="about digikala"
              />
            </motion.button>
          ) : (
            <motion.button
              key={mobileMenuOpen ? uuid() : "hamberuuid"}
              className="d-flex align-items-center justify-content-center p-0"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              initial={{ rotate: -80 }}
              animate={{ rotate: 0 }}
              transition={{ stiffness: 100 }}
            >
              <Image
                width={20}
                height={14}
                src={hamberSvg}
                alt="about digikala"
              />
            </motion.button>
          )} */}
          <span
            className={cx(
              styles.logoContainerVerticalLine,
              "d-flex",
              "d-lg-none",
              scroll && styles.secondLogoContainerVerticalLine
            )}
          ></span>
        </div>
        <div
          onClick={() => router.push("/")}
          className={cx(
            styles.logoContainer,
            "d-flex",
            "align-items-center",
            "justify-content-center"
          )}
        >
          <Image
            alt="about digikala"
            src={redSmyle}
            width="100%"
            height="100%"
          />
          <h3 className={cx(styles.logoContainerTitle, "p-0")}>
            درباره گروه دیجی‌کالا
          </h3>
          <span
            className={cx(
              styles.logoContainerVerticalLine,
              "d-lg-flex",
              "d-none",
              scroll && styles.secondLogoContainerVerticalLine
            )}
          ></span>
        </div>
        {/* desktop mainMenu */}
        {/* desktop mainMenu */}
        {/* desktop mainMenu */}
        <div
          className={cx(
            styles.menuContainer,
            "d-lg-flex",
            "aling-items-center",
            "justify-content-start",
            "flex-fill",
            "d-none",
            "h-100"
          )}
        >
          {navMainTitle.map((item, index) => (
            <motion.button
              onMouseOver={() => {
                setSubMenuOpen(true);
                setActiveSubMenu(item.id);
              }}
              onClick={() => setSubMenuOpen(true)}
              initial={{ x: 20, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ delay: 0.1 * index, stiffness: 90 }}
              className={cx(
                "p-0",
                styles.mainMenuBtn,
                "d-flex",
                "align-items-center",
                "justify-content-center",
                "h-100",
                "m-0"
              )}
              key={item.uuid}
            >
              {item.isLink ? (
                <Link
                  // target="_blank"
                  className={cx(styles.desktopMainLink)}
                  href={item.mainLink}
                  aria-label={item.mainLink}
                >
                  {item.mainTitle}
                </Link>
              ) : (
                item.mainTitle
              )}
            </motion.button>
          ))}
        </div>
        <div
          className={cx(
            styles.leftMenu,
            "d-flex",
            "align-items-center",
            "justify-content-center"
          )}
        >
          {/* <span
            className={cx(
              styles.logoContainerVerticalLine,
              "d-flex",
              "d-lg-none",
              scroll && styles.secondLogoContainerVerticalLine
            )}
          ></span>
          <button className={cx("p-0", styles.searchBtn)}>
            <Image alt="about digikala" src={searchIconSvg} />
          </button> */}
          <span
            className={cx(
              styles.logoContainerVerticalLine,
              "d-flex",
              "d-lg-none",
              scroll && styles.secondLogoContainerVerticalLine
            )}
          ></span>
          <button
            className={cx(
              "p-0",
              styles.enLangButtonStyles,
              "d-flex",
              "align-items-center",
              "justify-content-center"
            )}
            id="navbarEnLang"
            aria-label="change language navbar"
          >
            <Link
              aria-label="english about digikala"
              href={`https://about.digikala.com/en/home/${sharedData.utmParams}`}
            >
              En
            </Link>
          </button>
        </div>
      </div>

      {/* desktop sub menu */}
      {/* desktop sub menu */}
      {/* desktop sub menu */}
      <motion.div
        // style={{
        //   borderTop: !scroll && "1px solid #e0e0e0",
        // }}
        key={desktopSubMenuUuid}
        initial={{ y: "-100%", opacity: 0, display: "none" }}
        animate={{
          y: subMenuOpen ? 0 : "-100%",
          opacity: subMenuOpen ? 1 : 0,
          display: subMenuOpen ? "flex" : "none",
        }}
        transition={{ stiffness: 100 }}
        className={cx(
          styles.subMenuContainer,
          "w-100",
          "align-items-start",
          "justify-content-start"
        )}
      >
        {navbarData
          .filter((i) => i.id === activeSubMenu)[0]
          ?.subMenu?.map((item, index) => (
            <motion.button
              initial={{ y: -10, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.1 * index, stiffness: 90 }}
              key={item.uuid}
              className={cx(
                "p-0",
                styles.desktopSubMenuBtn,
                "d-flex",
                "align-items-center",
                "justify-content-center"
              )}
            >
              <Link aria-label={item.title} href={item.link}>
                {item.title}
              </Link>
            </motion.button>
          ))}
      </motion.div>

      {/* mobile main menu */}
      {/* mobile main menu */}
      {/* mobile main menu */}
      <motion.div
        key={mobileMainMenuUuid}
        initial={{ x: "100%", opacity: 0, display: "none" }}
        animate={{
          x: mobileMenuOpen ? 0 : "100%",
          opacity: mobileMenuOpen ? 1 : 0,
          display: mobileMenuOpen ? "flex" : "none",
        }}
        transition={{ stiffness: 90 }}
        className={cx(
          styles.mobileSubMenuContainer,
          "w-100",
          "flex-column",
          "align-items-center",
          "justify-content-start"
        )}
      >
        {!subMobileMenuOpen &&
          navMainTitle.map((item, index) => (
            <motion.button
              onClick={() => {
                onSubMobileMenuHandler(item.id);

                if (item.isLink) {
                  setMobileMenuOpen(false);
                  setSubMobileMenuOpen(false);
                }
              }}
              initial={{ x: 20, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ delay: 0.1 * index }}
              className={cx(
                "p-0",
                styles.mobileMainMenuBtn,
                "d-flex",
                "align-items-center",
                "justify-content-between",
                "w-100"
              )}
              key={item.uuid}
            >
              {item.isLink ? (
                <Link
                  aria-label={item.title}
                  className={cx(
                    styles.desktopMainLink,
                    "w-100",
                    "d-flex",
                    "align-items-center",
                    "justify-content-between"
                  )}
                  href={item.mainLink}
                >
                  {item.mainTitle}
                </Link>
              ) : (
                <>
                  {item.mainTitle}
                  <motion.div
                    initial={{ x: 20, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    transition={{ delay: 0.2 * index, stiffness: 90 }}
                    key={item.uuid}
                  >
                    <svg
                      width="14"
                      height="12"
                      viewBox="0 0 14 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.99989 1L1.00184 5.93161L6 10.9297"
                        stroke="#e0e0e0"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M1 5.93359L13 5.93359"
                        stroke="#e0e0e0"
                        strokeLinecap="round"
                      />
                    </svg>
                  </motion.div>
                </>
              )}
            </motion.button>
          ))}
        {/* mobile sub menu title */}
        {/* mobile sub menu title */}
        {/* mobile sub menu title */}
        {subMobileMenuOpen &&
          navMainTitle
            .filter((i) => i.id === activeSubMobileMenu)
            .map((item, index) => (
              <motion.button
                onClick={() => setSubMobileMenuOpen(false)}
                initial={{ y: -10, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.1 * index, stiffness: 90 }}
                key={item.uuid}
                className={cx(
                  "p-0",
                  styles.mobileSubMenuBtnTitle,
                  "d-flex",
                  "align-items-center",
                  "justify-content-center",
                  "w-100",
                  "position-relative"
                )}
              >
                <motion.div
                  initial={{ x: 20, opacity: 0, rotate: 180 }}
                  animate={{ x: 0, opacity: 1, rotate: 180 }}
                  transition={{ delay: 0.2 * index }}
                  key={item.uuid}
                  className={cx(styles.rightArrowTitlSubStyles, "d-flex")}
                >
                  <svg
                    width="14"
                    height="12"
                    viewBox="0 0 14 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5.99989 1L1.00184 5.93161L6 10.9297"
                      stroke="#e0e0e0"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M1 5.93359L13 5.93359"
                      stroke="#e0e0e0"
                      strokeLinecap="round"
                    />
                  </svg>
                </motion.div>
                {item.mainTitle}
              </motion.button>
            ))}

        {/* mobile sub menu */}
        {/* mobile sub menu */}
        {/* mobile sub menu */}
        {subMobileMenuOpen &&
          navbarData
            .filter((i) => i.id === activeSubMobileMenu)[0]
            ?.subMenu?.map((item, index) => (
              <motion.button
                initial={{ y: -10, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.1 * index, stiffness: 90 }}
                key={item.uuid}
                className={cx(
                  "p-0",
                  styles.mobileSubMenuBtn,
                  "d-flex",
                  "align-items-center",
                  "justify-content-between",
                  "w-100"
                )}
                onClick={() => {
                  setMobileMenuOpen(false);
                  setSubMobileMenuOpen(false);
                }}
              >
                <Link
                  className="w-100 d-flex align-items-center justify-content-between"
                  aria-label={item.title}
                  href={item.link}
                >
                  {item.title}
                  <motion.div
                    initial={{ x: 20, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    transition={{ delay: 0.2 * index, stiffness: 90 }}
                    key={uuid()}
                  >
                    <svg
                      width="14"
                      height="12"
                      viewBox="0 0 14 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.99989 1L1.00184 5.93161L6 10.9297"
                        stroke="#e0e0e0"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M1 5.93359L13 5.93359"
                        stroke="#e0e0e0"
                        strokeLinecap="round"
                      />
                    </svg>
                  </motion.div>
                </Link>
              </motion.button>
            ))}
      </motion.div>
    </div>
  );
};

export default MainNavbar1Dark;
